<template>
    <system-tabs :tabs="tabs">
        <template slot="help">
            <helpBrowser/>
        </template>

        <template slot="w1">
            <interface-browser :tabs="browserTabs" @event="onEvent"/>
        </template>
    </system-tabs>
</template>

<script>
    import InterfaceBrowser from '@/components/interface/browser'
    import SystemTabs from '@/components/system/tabs'
    import helpBrowser from '@/components/interface/browser/help'

    export default {
        components: {
            InterfaceBrowser,
            SystemTabs,
            helpBrowser
        },
        data () {
            return {
                actions: {
                    free: false,
                    subscribe: false,
                    pay: false
                },
                browserTabs: [{
                    title: 'Поиск',
                    url: '/web/search?q=онлайн%20кинотеатр&disabled=1'
                }],
                tabs: [
                    {
                        title: 'Браузер',
                        name: 'browser',
                        slot: 'w1'
                    }
                ]
            }
        },
        methods: {
            onEvent (event) {
                if (event.name === 'registered') {
                    if (event.data.site === 'online-cinema-free') {
                        this.actions.free = true
                    } else if (event.data.site === 'online-cinema-pay') {
                        this.actions.pay = true
                    } else if (event.data.site === 'online-cinema-subscribe') {
                        this.actions.subscribe = true
                    }
                    this.$store.dispatch('questions/answer', this.actions)
                }
            },

            // Завершение теста
            // Выполнение необходимых действий перед
            // переходом к следующему заданию / этипу
            finish () {}
        }
    }
</script>
